import styled from 'styled-components';

export const ReportingConnectResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: fit-content;
  border-radius: 12px;
  background-color: ${(props) => props.theme.newPalette.neutral.N0};
  border: 1px solid ${(props) => props.theme.newPalette.neutral.N400};
  padding: 30px 20px;
  max-width: 450px;
  @media screen and (min-width: 0px) and (max-width: 480px) {
    height: 100%;
    width: 100%;
    border: none;
  }
`;

export const ReportingConnectResultText = styled.div`
  ${(props) => props.theme.newTypography.textStyleBodyLarge};
  font-weight: 500;
  text-align: center;
`;

export const ReportingConnectResultHeader = styled.div`
  ${(props) => props.theme.newTypography.textStyleDisplayMedium};
  font-weight: 600;
  text-align: center;
  padding-bottom: 10px;
`;

export const ReportingConnectResultLogo = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding-bottom: 20px;
`;
